// "Send me back where I was going after I sign in."
//
// A deep link — most importantly the renewal email's
// /User/RequestQuote?renew=… — has to survive a detour through /signin. The
// return path travels as a `?next=` query parameter rather than router state,
// because the most common way a customer arrives signed out is with a stale
// session on disk: AuthContext's clearAndLogout() then does a full-page
// `window.location.href` to /signin, which wipes router state. A query
// parameter survives that reload, a refresh of the sign-in page, and the
// back button.

/**
 * The path to return to, or null. Only an in-app absolute path is accepted —
 * "/x", never "//host", "/\host" or a full URL — so `next` can never be turned
 * into an open redirect. Auth pages themselves are refused so a user can't be
 * bounced back into /signin after signing in.
 */
export function safeReturnPath(raw) {
  if (typeof raw !== "string" || !raw) return null;
  if (!raw.startsWith("/") || raw.startsWith("//") || raw.startsWith("/\\")) return null;
  const lower = raw.toLowerCase();
  if (lower === "/signin" || lower.startsWith("/signin?") || lower.startsWith("/signin/")) return null;
  return raw;
}

/** "/signin?next=<current path>" — or plain "/signin" for the root. */
export function signinUrlFor(pathWithSearch) {
  const next = safeReturnPath(pathWithSearch);
  return next && next !== "/" ? `/signin?next=${encodeURIComponent(next)}` : "/signin";
}

/** Reads and validates `next` from a location.search string. */
export function returnPathFromSearch(search) {
  return safeReturnPath(new URLSearchParams(search || "").get("next"));
}
